import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import {Helper} from '../../../../app/utils/helper.module';

import {FoEventsService} from "../../event/foevents.service";
import {ActivatedRoute, Router} from "@angular/router";
import {WeekPipe} from "../week.pipe";

import { isPlatformBrowser } from '@angular/common';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css'],
  providers :[ FoEventsService]
})

export class CategoriesComponent implements OnInit {
  events:any;
  categorie:any;
  pipe=new WeekPipe();
  selected:any;
  banner: string;
  event_trans:string = " ";
  other_event:string = " ";

  getBanner(name){
    name = name.toLowerCase();
    const banners = ['concerts', 'contact', 'festivals', 'spectacles', 'sports'];
    const other = 'autres';
    const folder = "assets/imgs/hero/";
    let path = folder+other.toUpperCase()+".png";

    if(banners.indexOf(name) > -1){
      path = folder+name.toUpperCase()+".png";
    }
    return path;
  }

  constructor(private translateService:TranslateService,@Inject(PLATFORM_ID) private platformId: Object, private eventservice :FoEventsService,private route:ActivatedRoute,private router:Router) {
    if (isPlatformBrowser(this.platformId)) {
      try {
        const $ = window['jQuery'];
        this.route.params.subscribe(params => {
          $('.navbar-toggler').trigger("click");
          this.banner = this.getBanner(params['categorie']);
          if (params['categorie'])
          {

            this.eventservice.categories(params['categorie']).then(any => {
              if(any != 'not found') {
                this.categorie = params['categorie'];
                this.events = any;
                this.selected = 'mois'
              }
              else if(params['categorie']!='login')
              {
                this.router.navigate(['notfound/categories']);
              }
              if (params['categorie']=='login')
              {
                this.router.navigate(['login/signin']);
              }
            });
          }

          //this.Monthevents();
        });
      } catch (e) {
        console.log("not in browser");
      }
    }
  }

  ngOnInit() {


  this.Monthevents();
    this.translateService.get('home.event_trans').subscribe(
      value => {
        this.event_trans = value.split(',');
      }
    )

    this.translateService.get('home.other_events').subscribe(
      value => {
        this.other_event = value.split(',');
      }
    )

  }

  slugify(string) {
    return string
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-\-+/g, "-")
      .replace(/^-+/, "")
      .replace(/-+$/, "");
  }



 // categories(): Promise<any[][]> {

  //  this.eventservice.categories(this.categorie).then(any => {
   //   this.events=any;

  //  });
  //  return ;

 // }

  Monthevents(): Promise<any[][]> {

    this.eventservice.categories(this.categorie).then(any => {
      if(any!='not found') {
        this.events = any;
        this.selected = 'mois'
      }

    });

    //console.log(arr);
    return ;

  }

  getWeeksevents(): Promise<any> {

    return this.eventservice.categories(this.categorie).then(any => {
      if(any!='not found') {
        this.events = this.pipe.transform(any)
        this.selected = 'semaine'
      }

    });
  }

  getFormatStartHour(time){
    return time.substr(0, 5);
  }

  getComingCategory(category){
    if(category){
      const tab = ['sports', 'clubbing'];

      if(tab.indexOf(category.toLowerCase()) > -1){
        return this.event_trans+" "+category.toLowerCase();
      }else if(category.toLowerCase() === "plus"){
        return this.other_event;
      }else{
        return category;
      }
    }
  }

}
